/**
 * Format a number as AUD currency for display.
 */
export function formatCurrency(amount) {
    if (amount === null || amount === undefined)
        return "$0";
    return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}
